import { render, staticRenderFns } from "./MaintaintaskDetail.vue?vue&type=template&id=fffcfb98&scoped=true&"
import script from "./MaintaintaskDetail.vue?vue&type=script&lang=js&"
export * from "./MaintaintaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./MaintaintaskDetail.vue?vue&type=style&index=0&id=fffcfb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffcfb98",
  null
  
)

export default component.exports